/* eslint-disable no-console */
/**
 * Logs the state (values only, no actions) of all common Zustand stores to the console.
 * Call when user is logged in (e.g. after initialization is ready) for debugging.
 */

import { useOnboardingStore } from '@apps/onboarding/stores/onboarding.store'
import { useGatewaysStore } from '@modules/gateways/stores/gateways.store'
import { useProjectsStore } from '@modules/projects/stores/projects.store'
import { useAccountStore } from '@modules/settings/account/stores/account.store'
import { useOrganizationsStore } from '@modules/settings/organizations/stores/organizations.store'
import { useWorkspaceStore } from '@modules/settings/workspace/stores/workspace.store'
import { useUserStore } from '@modules/user/stores/user.store'
import { useWorkspacesStore } from '@modules/workspaces/stores/workspaces.store'
import { useSessionStore } from '@stores/session/session.store'
import { StoreDevtoolsName } from '@stores/store-names.const'

const LOG_LABEL = '[Zustand] Stores (logged in)'

function getStoreValuesOnly<T extends object>(state: T): Record<string, unknown> {
  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(state)) {
    if (typeof value === 'function') continue
    result[key] = value
  }
  return result
}

export function logZustandStores(): void {
  if (typeof window === 'undefined') return

  try {
    const session = getStoreValuesOnly(useSessionStore.getState())
    const user = getStoreValuesOnly(useUserStore.getState())
    const workspaces = getStoreValuesOnly(useWorkspacesStore.getState())
    const projects = getStoreValuesOnly(useProjectsStore.getState())
    const onboarding = getStoreValuesOnly(useOnboardingStore.getState())
    const gateways = getStoreValuesOnly(useGatewaysStore.getState())
    const accountSettings = getStoreValuesOnly(useAccountStore.getState())
    const organizationsSettings = getStoreValuesOnly(useOrganizationsStore.getState())
    const workspaceSettings = getStoreValuesOnly(useWorkspaceStore.getState())

    console.group(LOG_LABEL)
    console.log(StoreDevtoolsName.Session, session)
    console.log(StoreDevtoolsName.User, user)
    console.log(StoreDevtoolsName.Workspaces, workspaces)
    console.log(StoreDevtoolsName.Projects, projects)
    console.log(StoreDevtoolsName.Onboarding, onboarding)
    console.log(StoreDevtoolsName.Gateways, gateways)
    console.log(StoreDevtoolsName.AccountSettings, accountSettings)
    console.log(StoreDevtoolsName.OrganizationsSettings, organizationsSettings)
    console.log(StoreDevtoolsName.WorkspaceSettings, workspaceSettings)
    console.groupEnd()
  } catch (e) {
    console.warn(LOG_LABEL, e)
  }
}
